// extracted by mini-css-extract-plugin
export default {"area-name":"SymptomsTable_area-name__LtO+S","symptom-name":"SymptomsTable_symptom-name__DBkZf"};